// Types
import type { Place } from '../../../server/src/types/place.types';

// Utils
import { filterByTranslation } from 'utils/filterGeneric';

export const filterPlaces = (
  places: Place[] | undefined,
  search: string
): Place[] => filterByTranslation(places, search);
